import { render, staticRenderFns } from "./Shopping.html?vue&type=template&id=3ee4aff8&scoped=true&"
import script from "./Shopping.ts?vue&type=script&lang=ts&"
export * from "./Shopping.ts?vue&type=script&lang=ts&"
import style0 from "./Shopping.css?vue&type=style&index=0&id=3ee4aff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee4aff8",
  null
  
)

export default component.exports